/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextEntityAttributeEditor } from "cms/entity/entity-attributes/entity-text/entity-text-editor";
import { FileEntityAttributeEditor } from "cms/entity/entity-attributes/entity-file/entity-file-editor";
import { DateEntityAttributeEditor } from "cms/entity/entity-attributes/entity-date/entity-date-editor";
import { TimeEntityAttributeEditor } from "cms/entity/entity-attributes/entity-time/entity-time-editor";
import { DateTimeEntityAttributeEditor } from "cms/entity/entity-attributes/entity-datetime/entity-datetime-editor";
import { SelectEntityAttributeEditor } from "cms/entity/entity-attributes/entity-select/entity-select-editor";
import { NumberEntityAttributeEditor } from "cms/entity/entity-attributes/entity-number/entity-number-editor";

export const getEntityAttributeEditor = (type) => {
    const parts = type.split(":");
    const baseType = parts[0];
    const subType = parts[1];
    const hasSubType = !!subType;
    let editorType = baseType;
    if (hasSubType) {
        editorType = subType;
    }
    // const isList = baseType === "array";

    const editors = {
        "date": DateEntityAttributeEditor,
        "time": TimeEntityAttributeEditor,
        "datetime": DateTimeEntityAttributeEditor,
        "text": TextEntityAttributeEditor,
        "select": SelectEntityAttributeEditor,
        "number": NumberEntityAttributeEditor,
        "file": FileEntityAttributeEditor,

        "email": TextEntityAttributeEditor,
        "phone": TextEntityAttributeEditor,
        "address": TextEntityAttributeEditor,
    };

    const editor = editors[editorType];
    return editor;
};
    
